import React from 'react'
import { Col, Form, Input } from 'antd'
import { get } from 'lodash'

const { TextArea } = Input

function DepartmentForm (props) {
  const { getFieldDecorator } = props.form
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14, offset: 1 },
    },
  }
  const { department } = props

  return (
    <Form>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Name">
          {getFieldDecorator('name', {
            initialValue: get(department, 'name'),
          })(<Input/>)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Details">
          {getFieldDecorator('details', {
            initialValue: get(department, 'details'),
          })(<TextArea/>)}
        </Form.Item>
      </Col>
    </Form>
  )
}

DepartmentForm.propTypes = {}
DepartmentForm.defaultProps = {}

export default Form.create()((DepartmentForm))
